var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6EDFF"
    },
    d: "M430.887,456.435H51.52c-4.915,0-8.9-3.985-8.9-8.9l0,0c0-4.915,3.985-8.9,8.9-8.9h379.367 c4.915,0,8.9,3.985,8.9,8.9l0,0C439.787,452.451,435.802,456.435,430.887,456.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFD2FF"
    },
    d: "M434.182,281.907c-0.161-0.096-0.323-0.192-0.486-0.286c-11.51-6.701-25.075-9.281-38.154-12.508 c-12.148-2.997-25.792-7.025-35.122-15.88c-11.34-10.762-9.759-25.587-5.398-39.065c4.577-14.144,8.898-28.385,6.874-43.404 c-2.306-17.112-10.011-33.627-22.252-46.465c-18.994-19.921-48.423-30.482-76.614-27.493 c-37.833,4.011-68.901,30.092-92.489,58.345c-15.477,18.539-24.615,39.591-42.268,57.195 c-17.451,17.402-37.056,33.084-51.745,52.801c-19.553,26.247-29.072,59.718-22.726,91.258 c6.346,31.539,29.53,60.321,61.279,71.706c20.221,7.251,42.397,7.399,64.023,7.455c44.916,0.117,89.893,0.233,134.664-3.174 c29.465-2.242,59.321-6.146,86.165-17.848c26.844-11.702,50.606-32.247,59.407-58.928 C468.085,329.108,458.986,296.697,434.182,281.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6EDFF"
    },
    d: "M73.272,219.376c-0.713-2.541-1.998-4.747-3.858-6.619c-1.012-0.782-2.024-1.564-3.036-2.345 c-2.34-1.357-4.863-2.04-7.571-2.048h-0.742c-2.065-0.078-3.991,0.353-5.779,1.292c-1.86,0.605-3.469,1.639-4.827,3.102 c-1.463,1.359-2.497,2.968-3.102,4.827c-0.939,1.788-1.37,3.714-1.292,5.779c0.179,1.329,0.357,2.658,0.536,3.988 c0.713,2.541,1.998,4.747,3.858,6.619c1.012,0.782,2.024,1.564,3.036,2.345c2.34,1.357,4.863,2.039,7.571,2.048h0.742 c2.065,0.078,3.992-0.353,5.779-1.292c1.86-0.605,3.469-1.639,4.827-3.102c1.463-1.359,2.497-2.968,3.102-4.827 c0.939-1.788,1.37-3.714,1.292-5.779C73.629,222.035,73.45,220.706,73.272,219.376z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BFD2FF"
    },
    cx: 442.488,
    cy: 204.203,
    r: 32.412
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6EDFF"
    },
    d: "M321.222,54.712c-1.397,0.276-2.746,0.683-4.03,1.21c0.078,0.099,0.163,0.19,0.232,0.299 c1.053,1.684,0.542,3.902-1.142,4.956c-1.684,1.054-3.903,0.542-4.956-1.141c-0.074-0.119-0.123-0.245-0.182-0.369 c-1.063,0.928-2.034,1.957-2.899,3.072c0.125,0.049,0.251,0.088,0.372,0.152c1.754,0.931,2.421,3.108,1.489,4.863 c-0.931,1.754-3.109,2.421-4.863,1.489c-0.138-0.073-0.256-0.166-0.38-0.254c-0.458,1.329-0.79,2.714-0.984,4.141 c0.148-0.024,0.292-0.056,0.446-0.061c1.985-0.07,3.651,1.482,3.721,3.466c0.07,1.985-1.482,3.651-3.466,3.721 c-0.174,0.006-0.342-0.015-0.51-0.033c0.275,1.429,0.687,2.807,1.225,4.119c0.129-0.109,0.256-0.221,0.404-0.313 c1.684-1.053,3.902-0.542,4.956,1.142c1.053,1.684,0.542,3.903-1.142,4.956c-0.16,0.1-0.329,0.173-0.497,0.246 c0.948,1.091,2.001,2.087,3.145,2.971c0.06-0.171,0.12-0.342,0.207-0.507c0.932-1.754,3.109-2.421,4.863-1.489 c1.754,0.931,2.421,3.109,1.489,4.863c-0.094,0.177-0.209,0.336-0.327,0.49c1.357,0.466,2.772,0.802,4.231,0.992 c-0.036-0.185-0.07-0.37-0.077-0.564c-0.07-1.985,1.482-3.651,3.467-3.721c1.985-0.07,3.651,1.482,3.721,3.466 c0.007,0.203-0.013,0.399-0.039,0.594c1.445-0.284,2.836-0.71,4.16-1.262c-0.123-0.142-0.246-0.285-0.348-0.449 c-1.053-1.684-0.542-3.902,1.142-4.956c1.684-1.053,3.902-0.542,4.956,1.142c0.103,0.165,0.179,0.339,0.253,0.513 c1.085-0.955,2.074-2.016,2.95-3.166c-0.167-0.059-0.334-0.117-0.494-0.202c-1.754-0.932-2.421-3.109-1.489-4.863 c0.932-1.754,3.108-2.421,4.863-1.489c0.16,0.085,0.301,0.191,0.442,0.295c0.452-1.344,0.775-2.745,0.958-4.188 c-0.159,0.027-0.316,0.06-0.482,0.066c-1.985,0.07-3.651-1.482-3.721-3.466c-0.07-1.985,1.482-3.651,3.467-3.721 c0.162-0.006,0.317,0.016,0.474,0.031c-0.285-1.413-0.705-2.774-1.248-4.071c-0.113,0.091-0.218,0.188-0.344,0.267 c-1.684,1.053-3.902,0.542-4.956-1.142c-1.053-1.684-0.542-3.903,1.142-4.956c0.124-0.077,0.255-0.129,0.384-0.189 c-0.935-1.058-1.971-2.023-3.091-2.881c-0.048,0.121-0.085,0.244-0.148,0.362c-0.932,1.754-3.109,2.421-4.863,1.489 c-1.754-0.931-2.421-3.108-1.489-4.863c0.064-0.12,0.147-0.222,0.222-0.332c-1.316-0.444-2.687-0.764-4.098-0.949 c0.017,0.121,0.045,0.238,0.05,0.363c0.07,1.985-1.482,3.651-3.467,3.721c-1.985,0.07-3.651-1.482-3.721-3.466 C321.192,54.97,321.212,54.843,321.222,54.712z M325.013,63.593c6.902-0.244,12.695,5.153,12.939,12.054 c0.244,6.902-5.153,12.695-12.054,12.939c-6.902,0.244-12.695-5.153-12.939-12.054 C312.715,69.631,318.112,63.837,325.013,63.593z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E6EDFF"
    },
    cx: 90.25,
    cy: 146.361,
    rx: 40.484,
    ry: 37.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#628AEC"
    },
    d: "M89.29,146.934l-31.574-10.106c-1.235,3.249-1.866,6.665-1.866,10.106 c0,16.834,15.095,30.686,33.44,30.686c6.061,0,12.009-1.512,17.207-4.374L89.29,146.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFD2FF"
    },
    d: "M91.023,146.361l17.427,26.189c4.891-2.74,8.932-6.589,11.736-11.174 c2.804-4.586,4.277-9.757,4.277-15.015H91.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFF"
    },
    d: "M91.214,144.883l33.436-0.424c-0.063-4.175-1.054-8.295-2.912-12.107 c-1.858-3.812-4.545-7.235-7.895-10.061L91.214,144.883z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 175.094,
    y: 110.024,
    style: {
      fill: "#628AEC"
    },
    width: 12.106,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.809,
    y: 95.783,
    style: {
      fill: "#628AEC"
    },
    width: 12.106,
    height: 43.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.525,
    y: 76.13,
    style: {
      fill: "#628AEC"
    },
    width: 12.106,
    height: 62.994
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.24,
    y: 103.681,
    style: {
      fill: "#628AEC"
    },
    width: 12.106,
    height: 35.442
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#628AEC",
      strokeWidth: 0.8763,
      strokeMiterlimit: 10
    },
    points: "168.607,76.738 168.607,138.856  251.342,138.856  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFD2FF"
    },
    d: "M354.544,95.439c-2.748,0.542-5.398,1.342-7.925,2.38c0.153,0.195,0.321,0.373,0.456,0.588 c2.071,3.31,1.066,7.673-2.245,9.744c-3.311,2.071-7.674,1.066-9.744-2.245c-0.146-0.234-0.242-0.482-0.358-0.725 c-2.089,1.825-4,3.847-5.7,6.039c0.245,0.097,0.494,0.173,0.732,0.299c3.449,1.831,4.76,6.112,2.928,9.561 c-1.831,3.449-6.112,4.76-9.561,2.928c-0.27-0.143-0.503-0.327-0.747-0.499c-0.901,2.613-1.554,5.336-1.935,8.143 c0.29-0.047,0.575-0.109,0.876-0.12c3.902-0.138,7.178,2.913,7.316,6.816c0.138,3.902-2.913,7.178-6.816,7.316 c-0.342,0.012-0.672-0.03-1.003-0.066c0.54,2.81,1.352,5.519,2.408,8.099c0.254-0.214,0.503-0.434,0.794-0.615 c3.311-2.071,7.673-1.066,9.744,2.245c2.071,3.311,1.066,7.673-2.244,9.744c-0.315,0.197-0.646,0.341-0.978,0.483 c1.865,2.145,3.934,4.104,6.183,5.841c0.117-0.336,0.235-0.674,0.408-0.998c1.832-3.449,6.112-4.76,9.561-2.928 c3.448,1.831,4.759,6.112,2.928,9.561c-0.185,0.349-0.411,0.66-0.643,0.964c2.667,0.916,5.45,1.576,8.319,1.951 c-0.071-0.363-0.138-0.728-0.152-1.109c-0.138-3.902,2.914-7.178,6.816-7.316c3.903-0.138,7.178,2.913,7.317,6.816 c0.014,0.399-0.026,0.784-0.076,1.167c2.841-0.558,5.576-1.396,8.18-2.482c-0.243-0.279-0.483-0.56-0.685-0.883 c-2.071-3.311-1.066-7.673,2.245-9.744c3.31-2.071,7.673-1.066,9.744,2.245c0.203,0.325,0.353,0.666,0.498,1.008 c2.134-1.878,4.077-3.964,5.8-6.224c-0.328-0.116-0.656-0.229-0.972-0.397c-3.449-1.832-4.76-6.112-2.928-9.561 c1.831-3.449,6.111-4.76,9.561-2.928c0.314,0.167,0.591,0.375,0.869,0.581c0.889-2.642,1.525-5.397,1.883-8.234 c-0.312,0.054-0.621,0.118-0.947,0.129c-3.902,0.138-7.178-2.913-7.316-6.816c-0.138-3.902,2.914-7.178,6.816-7.316 c0.318-0.011,0.624,0.031,0.932,0.061c-0.561-2.778-1.387-5.455-2.453-8.005c-0.221,0.179-0.429,0.37-0.677,0.525 c-3.31,2.071-7.673,1.066-9.744-2.245c-2.071-3.31-1.066-7.673,2.245-9.744c0.243-0.152,0.502-0.253,0.755-0.372 c-1.839-2.079-3.874-3.977-6.078-5.665c-0.095,0.238-0.168,0.48-0.291,0.711c-1.832,3.449-6.112,4.76-9.561,2.928 c-3.449-1.831-4.76-6.112-2.928-9.561c0.125-0.236,0.288-0.437,0.435-0.653c-2.587-0.873-5.282-1.502-8.057-1.867 c0.033,0.238,0.089,0.468,0.097,0.714c0.138,3.902-2.913,7.178-6.816,7.316c-3.902,0.138-7.178-2.913-7.316-6.816 C354.484,95.945,354.525,95.695,354.544,95.439z M361.849,108.675c15.903-0.563,29.252,11.873,29.815,27.776 c0.563,15.903-11.873,29.252-27.776,29.815c-15.903,0.563-29.252-11.873-29.815-27.776 C333.51,122.587,345.946,109.238,361.849,108.675z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M313.03,131.838c-0.869-0.635-1.948-1.172-2.284-2.195c-0.541-1.648,1.225-3.363,0.789-5.041 c-0.366-1.41-2.04-1.979-3.48-2.194c-1.441-0.215-3.093-0.414-3.916-1.616c-0.685-1-0.524-2.325-0.684-3.527 c-0.322-2.423-2.182-4.572-4.534-5.238c-2.504-0.71-4.684,1.56-6.773,2.471c-2.28,0.995-3.674,2.935-4.184,5.398 c-0.488,2.353-0.139,4.797,0.375,7.145c0.514,2.348,1.194,4.673,1.372,7.07c0.199,2.669-0.398,5.015-1.131,7.544 c-0.495,1.707-0.61,4.112,0.309,5.686c0.907,1.554,2.742,2.279,4.471,2.777c3.354,0.966,6.894,1.492,10.345,0.97 c3.267-0.494,6.444-2.018,8.569-4.534c1.513-1.263,2.727-2.85,3.408-4.696C316.966,138.38,316.023,134.027,313.03,131.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6EA1"
    },
    d: "M295.665,119.73c0.424,1.451,0.23,3.071-0.526,4.38c-0.248,0.43-0.64,0.869-1.135,0.834 c-0.57-0.04-0.888-0.665-1.068-1.207c-0.497-1.494-0.812-3.049-0.936-4.618c-0.076-0.963,0.104-2.699,1.471-2.366 C294.531,117.011,295.394,118.803,295.665,119.73z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6EA1"
    },
    d: "M295.662,143.277c-1.007,3.512-6.719,5.209-10.006,1.16c-0.403-0.497-0.777-1.02-1.14-1.547 c-3.545,0.696-8.816,2.24-11.184,5.115c-0.765,0.929-1.138,2.111-1.478,3.266c-1.238,4.205-2.264,8.472-3.072,12.78 c-0.092,0.492-0.18,1.012-0.014,1.484c0.204,0.581,0.742,0.965,1.226,1.346c4.898,3.862,6.185,10.097,7.796,15.734 c2.446,8.555,3.574,20.387,6.02,28.942c8.013,0.616,41.398-6.958,45.415-10.475c-5.76-10.372-10.423-29.084-12.249-42.103 c-0.774-5.516-2.939-10.77-5.049-15.935c-0.494-1.209-0.941-4-1.856-4.783c-1.219-1.042-12.853,0.719-14.085,0.76 c0.044,0.687,0.076,1.374,0.094,2.062C296.102,141.883,295.86,142.587,295.662,143.277z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_18_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC1A6"
    },
    d: "M283.763,137.618c-0.387-1.219-0.91-2.382-1.574-3.455c1.99-0.063,3.854-0.704,5.478-1.863 c0.799-0.57,1.519-1.241,2.205-1.941c0.244-0.249,0.616-0.883,1.006-1.338c-0.527,0.615,0.772,4.081,1.033,4.789 c0.544,1.479,1.309,2.948,2.37,4.125c1.052,1.167,1.741,1.364,1.926,3.014c0.195,1.742-0.171,3.656-0.764,5.289 c-0.371,1.021-0.91,2.042-1.825,2.628c-1.066,0.683-2.451,0.647-3.676,0.326c-2.071-0.542-4.912-2.269-5.652-4.432 c-0.388-1.134,0.047-1.715,0.151-2.876C284.567,140.461,284.19,138.963,283.763,137.618z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3856D"
    },
    d: "M284.461,141.316c-0.001-0.117-0.001-0.233-0.01-0.351c-0.096-1.133-0.345-2.266-0.688-3.347 c-0.387-1.219-0.91-2.382-1.574-3.455c1.99-0.063,3.854-0.704,5.478-1.863c0.799-0.57,1.519-1.241,2.205-1.941 c0.244-0.249,0.616-0.883,1.006-1.338c0.059,0.643,0.149,1.279,0.264,1.907C290.869,135.023,288.065,139.447,284.461,141.316z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M271.27,126.505c0.792,3.222,2.672,6.167,5.261,8.241c0.706,0.566,1.482,1.077,2.358,1.301 s1.872,0.123,2.582-0.438c1.009-0.799,1.179-2.241,1.253-3.526c0.139-2.406,0.218-4.84-0.229-7.209 c-0.448-2.368-1.467-4.693-3.236-6.329c-1.448-1.34-5.422-3.282-7.169-1.438C270.189,119.113,270.68,124.107,271.27,126.505z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC1A6"
    },
    d: "M273.336,120.838c0.34-2.265,2.904-0.583,4.983-1.545c1.809-0.836,3.177-1.559,5.217-1.416 c1.814,0.128,3.624,0.838,4.891,2.17c0.342,0.359,0.656,0.726,0.946,1.096c0.805,1.337,1.555,2.71,2.108,4.174 c0.007,0.033,0.014,0.065,0.021,0.098c0.19,2.907-0.508,5.652-1.878,8.019c-1.332,2.302-3.718,3.907-6.377,3.852 c-1.417-0.03-2.798-0.497-4.058-1.577c-1.258-1.078-2.182-2.491-2.983-3.941C274.986,129.561,272.961,123.333,273.336,120.838 z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M283.238,125.093c-2.47-0.585-5.021-0.941-7.292-2.064c-1.655-0.819-3.181-2.173-3.926-3.891 c-0.76-1.753-0.236-2.979,0.766-4.495c1.426-2.158,3.734-3.758,6.23-4.415c2.51-0.66,5.653,0.313,8.061,1.151 c1.674,0.582,3.271,1.498,4.401,2.863c1.961,2.368,2.629,6.451,2.474,9.445c-0.066,1.277-0.41,2.43-0.756,3.643 c-0.284,0.997-0.793,2.129-1.953,2.273c-0.796,0.099-2.389-2.171-3.202-2.677c-1.28-0.797-2.728-1.307-4.182-1.68 C283.653,125.193,283.445,125.142,283.238,125.093z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M279.442,127.812c0.041,0.398,0.397,0.688,0.795,0.648c0.398-0.041,0.689-0.397,0.648-0.795 c-0.041-0.398-0.397-0.688-0.795-0.648C279.691,127.057,279.401,127.413,279.442,127.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M280.522,125.734 c-0.486-0.101-1.005-0.033-1.448,0.19"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M274.955,129.019c0.041,0.398,0.397,0.688,0.795,0.648c0.398-0.041,0.688-0.397,0.648-0.795 c-0.041-0.398-0.397-0.688-0.795-0.648C275.204,128.264,274.914,128.62,274.955,129.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M276.035,126.941 c-0.486-0.101-1.005-0.033-1.448,0.19"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M277.578,129.102 c0.148,0.625,0.042,1.306-0.289,1.857c-0.086,0.143-0.19,0.296-0.165,0.461c0.027,0.177,0.205,0.3,0.383,0.325 s0.356-0.027,0.528-0.079"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M281.238,132.728 c-0.609,0.658-1.541,1.001-2.431,0.896"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC1A6"
    },
    d: "M291.671,125.241c0.15,1.462-0.915,2.769-2.378,2.919c-1.462,0.15-2.769-0.915-2.919-2.377 c-0.15-1.463,0.915-2.769,2.377-2.919C290.214,122.714,291.521,123.778,291.671,125.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M289.422,124.325c-0.388-0.01-0.776,0.193-0.988,0.518c-0.212,0.325-0.243,0.761-0.077,1.113 c0.207-0.233,0.562-0.322,0.854-0.213c0.292,0.108,0.504,0.406,0.51,0.718"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE4FF",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M353.4,434.108H142.448 c-4.827,0-8.74-3.913-8.74-8.74V307.007c0-4.827,3.913-8.74,8.74-8.74H353.4c4.827,0,8.74,3.913,8.74,8.74v118.361 C362.14,430.195,358.227,434.108,353.4,434.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAC5EF",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M379.05,434.281L379.05,434.281H116.798 l0,0c0,6.022,4.882,10.904,10.904,10.904h240.445C374.168,445.184,379.05,440.302,379.05,434.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545D78"
    },
    d: "M349.828,429.844H146.019c-3.772,0-6.83-3.058-6.83-6.83V310.431c0-3.772,3.058-6.83,6.83-6.83 h203.809c3.772,0,6.83,3.058,6.83,6.83v112.583C356.658,426.786,353.6,429.844,349.828,429.844z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M250.963,300.82c0,0.935-0.758,1.693-1.693,1.693c-0.935,0-1.693-0.758-1.693-1.693 c0-0.935,0.758-1.693,1.693-1.693C250.205,299.127,250.963,299.885,250.963,300.82z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.105,
    y: 215.981,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -54.3693 550.2167)",
    style: {
      fill: "#FEFEFF"
    },
    width: 253.637,
    height: 172.623
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6EDFF"
    },
    points: "263.776,408.984 240.805,380.365 220.829,405.962 203.513,387.251 205.776,385.156  220.629,401.205 240.771,375.396 263.142,403.268 276.126,376.756 303.537,371.909 304.074,374.946 278.207,379.52  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6EA1"
    },
    d: "M307.765,373.427c0-2.187-1.772-3.959-3.959-3.959c-2.187,0-3.959,1.773-3.959,3.959 c0,2.186,1.773,3.959,3.959,3.959C305.992,377.386,307.765,375.614,307.765,373.427z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#628AEC"
    },
    d: "M267.583,406.126c0-2.187-1.773-3.959-3.959-3.959c-2.187,0-3.959,1.773-3.959,3.959 c0,2.187,1.773,3.959,3.959,3.959C265.811,410.085,267.583,408.313,267.583,406.126z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB861"
    },
    d: "M280.664,378.138c0-2.187-1.772-3.959-3.959-3.959c-2.186,0-3.959,1.773-3.959,3.959 c0,2.187,1.773,3.959,3.959,3.959C278.892,382.097,280.664,380.324,280.664,378.138z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB861"
    },
    cx: 240.637,
    cy: 378.138,
    r: 3.959
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6EA1"
    },
    cx: 221.201,
    cy: 403.111,
    r: 3.959
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3FD4C7"
    },
    d: "M209.462,386.955c0-2.187-1.773-3.959-3.959-3.959s-3.959,1.773-3.959,3.959 c0,2.187,1.773,3.959,3.959,3.959S209.462,389.141,209.462,386.955z"
  }))), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    points: "188.083,361.942 188.083,415.932  308.562,415.932  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 197.668,
    y: 275.756,
    style: {
      fill: "#FFB861"
    },
    width: 18.387,
    height: 42.712
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.094,
    y: 254.854,
    style: {
      fill: "#FF6EA1"
    },
    width: 18.387,
    height: 63.615
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M194.239,263.516 c22.076-10.047,41.937-24.924,57.798-43.272"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#485070"
    },
    points: "253.72,218.268 252.411,221.995 251.869,220.354 250.176,220.012  "
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 254.521,
    y: 226.007,
    style: {
      fill: "#3FD4C7"
    },
    width: 18.387,
    height: 92.461
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.947,
    y: 266.446,
    style: {
      fill: "#628AEC"
    },
    width: 18.387,
    height: 52.022
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    points: "186.847,227.73 186.847,318.608  309.702,318.608  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.146,
    y: 327.38,
    style: {
      fill: "#E6EDFF"
    },
    width: 123.369,
    height: 6.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.614,
    y: 204.395,
    style: {
      fill: "#E6EDFF"
    },
    width: 74.138,
    height: 6.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.999,
    y: 193.544,
    style: {
      fill: "#E6EDFF"
    },
    width: 123.369,
    height: 6.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.146,
    y: 338.77,
    style: {
      fill: "#E6EDFF"
    },
    width: 123.369,
    height: 6.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.146,
    y: 350.16,
    style: {
      fill: "#E6EDFF"
    },
    width: 123.369,
    height: 6.213
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6EA1"
    },
    d: "M304.841,138.528c-1.438,0.339-2.865,0.74-4.283,1.14c-0.24,0.068-0.488,0.14-0.674,0.304 c-0.257,0.227-0.35,0.583-0.419,0.919c-0.93,4.521,0.336,10.496,3.246,14.132c0.879,1.099,1.922,2.054,2.874,3.09 c0.939,1.021,2.19,1.942,3.033,3.015c0.979,1.247,1.393,3.27,1.847,4.764c1.043,3.428,1.69,6.977,1.919,10.553 c0.152,2.375,0.264,5.078,2.087,6.609c1.805,1.518,4.669,1.13,6.534-0.315c1.864-1.444,2.92-3.686,3.715-5.907 c2.064-5.765,3.194-11.975,2.895-18.108c-0.272-5.589-1.983-12.321-5.594-16.742c-2.417-2.96-6.399-4.282-10.22-4.341 C309.451,137.607,307.133,137.988,304.841,138.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M308.26,172.016 c1.327-7.18,2.654-14.359,3.982-21.539"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M309.647,151.827 c0.459,1.173,0.918,2.345,1.377,3.518"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC1A6"
    },
    d: "M282.595,187.488c0.495-0.178,1.023-0.283,1.59-0.296c4.85-0.105,9.589-0.607,14.484-1.099 c3.277-0.329,6.556-0.518,9.821-0.565c2.634-0.038,5.683,0.535,8.247-0.189c2.715-0.767,4.562-1.528,5.92-3.774 c0.657-1.087,1.25-2.197,1.776-3.324c0.31-0.664,0.602-1.373,0.46-2.037c-0.21-0.986-1.3-1.585-2.37-1.978 c-2.275-0.836-3.681-2.138-6.292-2.405c-2.651-0.271-5.446,0.074-8.118,0.635c-5.202,1.092-10.407,1.543-15.513,3.062 c-5.769,1.716-11.284,4.117-16.737,6.555c-1.997,0.893-4.058,1.838-5.502,3.325c-2.216,2.281-2.462,5.677-0.566,7.809 c0.547,0.615,1.39,1.16,2.347,0.99c0.957-0.17,1.597-1.428,0.794-1.802C278.189,194.419,278.328,189.02,282.595,187.488z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6EA1"
    },
    d: "M266.173,188.32l0.036-0.321c-0.08,0.197-0.161,0.394-0.241,0.592 C266.037,188.5,266.105,188.41,266.173,188.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6EA1"
    },
    d: "M279.794,147.712c-0.301-0.565-0.736-1.04-1.336-1.391c-1.695-0.991-5.258,0.533-6.784,1.374 c-0.326,0.179-0.643,0.37-0.956,0.591c-1.836,1.163-3.449,2.753-4.86,4.299c-0.489,0.535-0.966,1.081-1.438,1.626 c-7.055,8.146-11.611,17.121-10.47,28.029c0.244,2.336,0.71,4.855,2.45,6.432c1.382,1.253,3.396,1.675,5.231,1.344 c1.743-0.315,3.325-1.256,4.628-2.461l-0.051,0.446c0.087-0.212,0.173-0.425,0.26-0.637c2.783-2.699,3.433-6.433,4.107-10.068 c0.002-0.008,0.003-0.016,0.005-0.025c2.211-5.427,4.422-10.855,6.633-16.282C278.27,158.393,281.682,151.262,279.794,147.712z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC1A6"
    },
    d: "M268.523,228.234c3.044-4.973-2.505-5.796-3.311-10.238c-0.093-0.515-0.107-1.054-0.016-1.62 c0.773-4.842,1.116-9.622,1.498-14.557c0.255-3.304,0.657-6.592,1.202-9.848c0.368-2.201,1.223-4.636,1.327-6.924 c-0.054-0.728-0.136-1.459-0.255-2.171c-0.893-1.674-2.32-3.001-4.567-3.732c-2.651-0.862-5.84-0.199-7.997,1.592 c-0.556,0.847-1.053,1.751-1.481,2.659c-0.562,2.358-0.676,4.863-0.593,7.294c0.182,5.317-0.298,10.555,0.342,15.83 c0.724,5.96,2.2,11.754,3.726,17.491c0.559,2.101,1.16,4.272,2.433,5.899c1.953,2.495,5.415,3.171,7.96,1.553 c0.735-0.467,1.451-1.237,1.449-2.211C270.238,228.278,269.055,227.482,268.523,228.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M268.949,183.03 c1.423-6.514,4.008-12.773,7.597-18.393"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M273.991,168.63 c0.868-0.559,1.736-1.119,2.603-1.678"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M119.675,294.079c3.722,4.254,5.248,9.99,6.513,15.362c1.635,6.944,3.27,13.888,4.905,20.831 c0.384,1.63,0.77,3.274,0.817,4.948c0.076,2.686-0.695,6.104-1.325,8.691c-0.809,3.321-2.796,3.116-5.754,2.822 c-4.678-0.465-11.042-1.88-14.199-5.694c-1.501-1.813-1.984-4.237-2.416-6.551c-0.595-3.182-1.189-6.364-1.784-9.545 c-2.43-13-4.859-26.41-2.11-39.346C110.873,286.572,115.85,289.707,119.675,294.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C5240"
    },
    d: "M126.551,335.195c2.068,0.981,4.048,2.244,6.039,3.442c3.162,1.903,6.462,3.242,9.701,5.01 c0.921,0.503,1.857,0.999,2.865,1.177c1.733,0.306,3.563-0.346,5.308-0.112c2.333,0.313,4.323,2.393,5.169,5.143 c1.424,4.631-1.911,2.907-4.121,2.502c-1.723-0.316-3.447-0.632-5.17-0.949c-6.775-1.243-13.276-1.841-20.218-2.201 c-3.771-0.195-10.416-0.108-13.237-3.545c-1.371-1.67-2.888-8.956-1.083-10.764c0.338-0.339,0.754-0.493,1.158-0.627 c3.62-1.204,7.335-1.251,10.835-0.168C124.737,334.396,125.652,334.769,126.551,335.195z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M124.099,388.764H57.955c-2.171,0-3.932-1.76-3.932-3.932l0,0c0-2.171,1.76-3.932,3.932-3.932 h66.144c2.171,0,3.932,1.76,3.932,3.932l0,0C128.031,387.004,126.271,388.764,124.099,388.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M50.975,336.889v-23.213c0-3.499,2.836-6.335,6.335-6.335h51.727c3.499,0,6.335,2.836,6.335,6.335 v23.213c0,3.499-2.836,6.335-6.335,6.335H57.31C53.811,343.224,50.975,340.388,50.975,336.889z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.219,
    y: 337.389,
    style: {
      fill: "#485070"
    },
    width: 4,
    height: 47.74
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.368,
    y: 337.389,
    style: {
      fill: "#485070"
    },
    width: 4,
    height: 47.74
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 86.955,
    y: 386.787,
    style: {
      fill: "#485070"
    },
    width: 4,
    height: 57.989
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.889,
    y: 386.787,
    style: {
      fill: "#485070"
    },
    width: 4,
    height: 57.989
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.006,
    y: 386.787,
    style: {
      fill: "#485070"
    },
    width: 4,
    height: 57.989
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.482,
    y: 386.787,
    style: {
      fill: "#485070"
    },
    width: 4,
    height: 57.989
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF9378"
    },
    d: "M165.023,407.139c-2.268,0.476-3.826,0.591-6.505,0.968c-3.896,0.549-7.804,1.005-11.723,1.343 c1.022,7.049,1.952,13.247,2.188,14.494c1.024,5.398,0.459,18.927,2.869,24.061c2.933,0.365,5.473-0.119,8.215-0.344 C161.523,434.13,162.719,420.551,165.023,407.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66A3F2"
    },
    d: "M144.59,419.014c0.007,1.099,0.031,2.238,0.253,3.309c3.101,3.276,7.748,4.963,12.219,5.183 c2.618,0.129,5.125-0.278,7.524-1.049c0.287-5.281,0.604-10.56,0.941-15.838c0.439-6.869,0.795-13.735,1.649-20.567 c0.38-3.037,0.83-12.047,0.101-18.465c-1.751-6.71-6.207-8.542-6.207-8.542s-12.462-4.931-22.004-7.026 c-11.714-2.572-23.62-4.48-35.402-7.046c-5.662-1.233-15.135-1.005-18.058,5.185c-3.382,7.162,3.361,16.683,8.792,20.819 c5.619,4.278,12.553,6.443,19.454,7.948c9.763,2.128,19.781,3.092,29.771,2.864C143.302,385.789,144.575,416.538,144.59,419.014z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M143.606,385.845c0.019-0.019,0.04-0.035,0.058-0.054c-2.177-2.162-4.232-4.451-6.408-6.611 c-3.24-3.215-6.386-6.53-9.604-9.769c-6.393-6.434-12.819-12.836-19.072-19.406c-1.64-0.335-3.279-0.676-4.916-1.033 c-5.662-1.234-15.135-1.005-18.058,5.185c-3.382,7.162,3.361,16.683,8.792,20.819c5.619,4.278,12.553,6.443,19.454,7.948 c9.763,2.128,19.781,3.092,29.771,2.864C143.615,385.788,143.611,385.821,143.606,385.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.3975,
      strokeMiterlimit: 10
    },
    d: "M143.695,387.75 c0.01-3.13,0.436-6.953,0.446-10.083"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M151.737,360.022 c-8.379-2.695-16.024-5.187-28.323-6.851"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M177.233,454.747h-25.859c-0.531,0-0.962-0.43-0.962-0.962v-1.941h26.82V454.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M176.856,452.634c0.093-0.135,0.183-0.273,0.253-0.426c0.65-1.43-0.112-3.153-1.358-4.168 c-1.246-1.015-2.873-1.483-4.449-1.925c-3.368-0.945-6.607-1.846-10.079-2.321c-0.914-0.125-10.679-1.02-10.637-1.461 c-0.151,2.462-0.302,4.924-0.453,7.387c-0.062,1.02-0.318,2.022-0.011,2.914H176.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M155.027,440.301c1.486-1.232,3.798-1.226,5.399-0.148c1.601,1.078,2.469,3.076,2.381,5.004 c-0.016,0.357-0.079,0.746-0.346,0.984c-0.267,0.238-0.659,0.255-1.017,0.259c-1.54,0.018-3.081,0.036-4.621,0.055 c-0.961,0.012-2.186,0.235-2.855-0.63C152.788,444.301,153.883,441.445,155.027,440.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B3B3B3",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M165.185,444.502 c-0.903-0.095-1.834,0.484-2.149,1.336"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B3B3B3",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M165.744,446.847 c0.473-0.78,1.364-1.289,2.276-1.301"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B3B3B3",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M169.135,447.214 c0.222-0.566,0.81-0.967,1.417-0.967"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF9378"
    },
    d: "M120.577,403.497c-3.433,0.484-6.879,0.88-10.33,1.202c2.609,12.834,3.813,25.901,5.941,38.816 c2.93-0.011,5.602-0.631,8.717-0.563c0.593-3.911,1.787-27.133,3.624-40.753C125.377,402.978,123.791,403.044,120.577,403.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66A3F2"
    },
    d: "M110.763,421.763c0.71,2.891,1.537,4.663,4.385,5.794c2.469,0.98,5.165,1.382,7.811,1.097 c3.554-0.383,6.446-2.985,6.446-2.985s3.675-54.792-0.897-61.813c-5.594-8.591-17.84-10.353-27.382-12.448 c-8.359-1.835-16.816-3.335-25.255-4.975c-2.059,7.813-0.572,17,2.414,24.205c0.015,0.037,0.031,0.074,0.046,0.111 c2.374,5.656,7.795,9.489,13.907,10.008c4.47,0.379,8.959,0.523,13.444,0.42C105.624,381.178,108.222,411.415,110.763,421.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.3975,
      strokeMiterlimit: 10
    },
    d: "M105.755,383.139 c0.01-3.13,0.436-6.952,0.446-10.083"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M142.312,454.328h-25.859c-0.531,0-0.962-0.43-0.962-0.962v-1.941h26.82V454.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M141.935,452.214c0.093-0.135,0.183-0.273,0.253-0.426c0.65-1.43-0.112-3.153-1.358-4.168 c-1.246-1.015-2.873-1.483-4.449-1.925c-3.368-0.945-6.607-1.846-10.079-2.321c-0.914-0.125-10.679-1.02-10.637-1.461 c-0.151,2.462-0.301,4.924-0.452,7.387c-0.062,1.02-0.318,2.022-0.011,2.914H141.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M120.105,439.881c1.486-1.232,3.798-1.226,5.399-0.148c1.601,1.078,2.469,3.076,2.381,5.004 c-0.016,0.357-0.079,0.746-0.346,0.984c-0.267,0.238-0.659,0.255-1.017,0.259c-1.54,0.018-3.081,0.036-4.621,0.055 c-0.961,0.012-2.186,0.235-2.855-0.63C117.867,443.881,118.961,441.025,120.105,439.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B3B3B3",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M130.264,444.082 c-0.903-0.095-1.834,0.484-2.149,1.336"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B3B3B3",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M130.822,446.428 c0.474-0.78,1.364-1.289,2.276-1.301"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B3B3B3",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M134.214,446.794 c0.222-0.566,0.81-0.967,1.417-0.967"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M74.743,357.021c0.236,1.26,0.473,2.521,0.709,3.781c4.352-2.288,9.557-1.81,14.473-1.818 c10.758-0.018,21.502-2.702,31.004-7.745c-0.534-2.675-1.144-5.251-1.158-7.943c-0.015-2.739-1.147-5.393-1.147-8.14 c-0.18-3.71-0.036-7.427,0.146-11.134c0.346-7.021,0.821-14.123-0.491-21.028c-0.852-4.482-2.528-8.895-5.25-12.583 c-1.25-1.694-2.982-3.889-4.901-4.863c-2.034-1.033-5.084-0.687-7.371-0.889c-1.673-0.148-3.369-0.295-5.024-0.012 c-2.042,0.35-3.916,1.336-5.692,2.401c-9.47,5.681-10.621,14.842-13.472,24.703c-1.424,4.925-3.655,9.588-5.084,14.512 c-0.798,2.752-1.128,5.616-1.059,8.478c0.063,2.587,1.058,4.893,1.534,7.435C72.888,347.124,73.816,352.073,74.743,357.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.3975,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M101.531,293.665 c1.75,1.49,4.086,2.272,6.38,2.135c0.796-0.047,1.617-0.215,2.246-0.705c0.629-0.49,1.006-1.368,0.719-2.112"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.3975,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M99.355,314.32 c2.027,6.738,7.391,12.383,14.016,14.753"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.3975,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M105.492,319.545 c1.717,2.059,4.248,3.42,6.912,3.716"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.3975,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M93.398,319.135 c2.431,7.686,6.797,14.752,12.584,20.363"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.3975,
      strokeMiterlimit: 10
    },
    d: "M115.194,293.288 c2.72,4.681,2.755,7.344,3.366,11.474c0.683,4.619,0.997,9.293,0.936,13.962c-0.102,7.831-1.832,15.005-0.083,22.772"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF9378"
    },
    d: "M109.5,283.196c0.415-1.308,0.977-2.555,1.689-3.707c-2.136-0.067-4.135-0.756-5.878-1.999 c-0.857-0.611-1.629-1.332-2.366-2.082c-0.262-0.267-0.661-0.947-1.079-1.436c-0.435,4.709-2.188,9.137-6.204,11.826 c1.355,2.477,3.629,4.338,6.066,5.752c2.094,1.214,7.312,3.561,7.428-0.681c0.038-1.388-0.513-2.671-0.394-4.081 C108.865,285.571,109.132,284.356,109.5,283.196z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C5240"
    },
    d: "M108.751,287.163c0.001-0.125,0.001-0.25,0.011-0.377c0.103-1.216,0.37-2.431,0.738-3.591 c0.415-1.308,0.977-2.555,1.689-3.707c-2.136-0.067-4.135-0.756-5.878-1.999c-0.857-0.611-1.629-1.332-2.366-2.082 c-0.262-0.267-0.661-0.947-1.079-1.436c-0.064,0.69-0.16,1.373-0.283,2.046C101.875,280.412,104.884,285.159,108.751,287.163z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M77.953,294.079c-3.722,4.254-5.248,9.99-6.513,15.362c-1.635,6.944-3.27,13.887-4.905,20.831 c-0.567,2.406-1.476,5.696-0.943,8.153c0.58,2.674,2.505,5.143,4.826,6.536c2.471,1.484,6.233,2.16,8.947,0.9 c2.659-1.235,5.701-2.491,7.631-4.822c1.501-1.813,1.983-4.237,2.416-6.551c0.595-3.182,1.189-6.364,1.784-9.545 c2.43-13,4.859-26.41,2.11-39.346C86.755,286.572,81.779,289.707,77.953,294.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.3975,
      strokeMiterlimit: 10
    },
    d: "M93.437,306.987 c-5.407,1.408-4.923,8.328-5.412,12.595c-0.724,6.304-1.926,12.553-3.595,18.676"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.3975,
      strokeMiterlimit: 10
    },
    d: "M89.377,310.542 c0.6-1.879,1.756-3.577,3.285-4.824"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF9378"
    },
    d: "M86.182,336.453c2.9,0.634,5.745,1.561,8.592,2.422c4.52,1.367,9.099,2.156,13.69,3.378 c1.305,0.347,2.629,0.686,3.979,0.699c2.321,0.022,4.562-0.917,6.883-0.968c3.103-0.068,6.135,1.664,7.822,4.241 c2.84,4.34-1.867,3.178-4.83,3.134c-2.31-0.034-4.62-0.067-6.93-0.101c-9.081-0.133-17.669,0.328-26.779,1.094 c-4.949,0.416-13.577,1.576-17.98-1.36c-2.139-1.427-5.665-8.372-3.701-10.448c0.368-0.389,0.876-0.608,1.374-0.806 c4.455-1.773,9.278-2.419,14.063-1.916C83.65,335.958,84.921,336.178,86.182,336.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC8B77"
    },
    d: "M152.466,339.872c-0.055,0-0.11,0-0.165,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M162.294,361.94h-60.003c-0.67,0-1.212-0.543-1.212-1.212v-0.413c0-0.67,0.543-1.212,1.212-1.212 h60.003c0.67,0,1.212,0.543,1.212,1.212v0.413C163.506,361.397,162.963,361.94,162.294,361.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757E96"
    },
    d: "M169.816,361.94h-53.347l4.642-30.654c0.161-1.064,1.065-1.858,2.114-1.858h49.118 c1.268,0,2.223,1.143,2.028,2.429L169.816,361.94z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 147.548,
    cy: 345.055,
    r: 3.545
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF9378"
    },
    d: "M120.07,263.682c-0.611-2.38-3.163-0.306-5.487-1.105c-2.022-0.695-3.561-1.318-5.723-0.942 c-1.923,0.334-3.776,1.29-4.984,2.85c-0.326,0.421-0.62,0.847-0.89,1.273c-0.713,1.515-1.364,3.062-1.794,4.685 c-0.004,0.036-0.008,0.071-0.012,0.107c0.115,3.124,1.159,5.977,2.88,8.355c1.673,2.311,4.394,3.765,7.226,3.415 c1.509-0.186,2.933-0.835,4.159-2.125c1.225-1.288,2.057-2.897,2.754-4.532C119.26,273.173,120.742,266.305,120.07,263.682z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M108.816,266.018c0.023-0.105,0.04-0.224,0.068-0.358c0.209-0.993,0.417-1.985,0.626-2.978 c2.51,1.875,5.234,4.548,8.483,5.627c2.458,0.816,5.231-0.091,6.787-2.14c0.282-0.371,0.494-0.765,0.703-1.179 c0.094-0.186,0.337-0.983,0.434-1.049c-0.869,0.597-2.123,0.168-2.825-0.619c-0.702-0.786-1.015-1.832-1.416-2.807 c-0.943-2.293-2.492-4.358-4.532-5.766c-2.04-1.408-4.579-2.128-7.04-1.834c-1.547,0.185-3.046,0.783-4.29,1.721 c-0.615,0.463-1.19,1.015-1.639,1.642c-0.208,0.291-1.091,1.884-0.734,2.192c-0.55-0.474-1.413-0.425-2.039-0.056 c-0.625,0.369-1.056,0.991-1.415,1.622c-1.527,2.683-2.082,5.891-1.611,8.937c0.21,1.356,0.703,2.549,1.204,3.806 c0.412,1.034,1.078,2.186,2.333,2.214c1.733,0.038,1.541-2.869,2.033-4.37c0.193-0.589,0.15-1.326,0.853-1.503 c0.712-0.179,1.859,1.171,2.407,0.066c0.197-0.398,0.102-0.872,0.013-1.308c-0.088-0.436-0.156-0.922,0.083-1.297 c0.023-0.036,0.918,0.003,1.053-0.044C108.679,266.426,108.763,266.259,108.816,266.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M104.538,253.969 c-1.354,1.806-1.634,4.359-0.704,6.416"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M99.76,257.856 c1.104-0.686,2.695-0.434,3.534,0.559"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#485070"
    },
    cx: 113.535,
    cy: 271.792,
    r: 0.778
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M112.934,269.692 c0.507-0.161,1.069-0.145,1.566,0.045"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M119.235,272.591c0,0.43-0.348,0.778-0.778,0.778c-0.43,0-0.778-0.348-0.778-0.778 c0-0.43,0.348-0.778,0.778-0.778C118.887,271.813,119.235,272.161,119.235,272.591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M117.856,270.492 c0.507-0.161,1.069-0.145,1.566,0.045"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M116.444,272.966 c-0.089,0.683,0.098,1.399,0.511,1.951c0.107,0.143,0.236,0.295,0.226,0.474c-0.01,0.192-0.186,0.343-0.373,0.389 c-0.187,0.046-0.383,0.01-0.572-0.026"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M112.933,277.236 c0.722,0.635,1.754,0.9,2.693,0.691"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF9378"
    },
    d: "M100.981,270.383c0,1.577,1.279,2.856,2.856,2.856c1.577,0,2.856-1.279,2.856-2.856 c0-1.577-1.279-2.856-2.856-2.856C102.26,267.526,100.981,268.805,100.981,270.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M103.281,269.16c0.413-0.053,0.849,0.121,1.111,0.445c0.262,0.324,0.342,0.786,0.204,1.179c-0.247-0.226-0.635-0.282-0.935-0.134 c-0.3,0.147-0.494,0.489-0.466,0.822"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M421.09,433.872c-0.082-0.36-10.294,1.426-11.423,1.602c-0.041,0.036-0.082,0.072-0.123,0.107 c-3.532,3.001-8.011,4.634-12.393,6.22c-0.678,0.245-1.384,0.51-1.85,1.056c-1.989,2.335,2.234,3.339,3.732,3.464 c2.453,0.206,4.879-0.289,7.255-0.707c4.918-0.865,9.937-0.585,14.806-1.787c0.192-0.048,0.398-0.106,0.514-0.264 c0.091-0.125,0.109-0.291,0.123-0.449C421.995,440.047,421.778,436.917,421.09,433.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757E96"
    },
    d: "M398.733,362.064c2.465,24.577,6.964,49.802,9.779,74.357c5.76,0.495,7.845,0.118,13.439-0.829 c3.666-26.711,5.219-39.603,1.912-66.699c-0.34-2.781-0.047-25.817-0.146-28.775c-0.586-17.612,1.766-37.716-8.811-52.588 c-2.671-3.756-7.048-6.638-11.497-6.29c-3.254,0.255-5.762,2.027-7.635,4.566c-5.465,7.416-2.416,27.568-1.444,36.366 C395.619,333.836,397.558,350.35,398.733,362.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545D78"
    },
    d: "M400.467,377.355c0.998-4.262,2.219-8.477,3.421-12.686c4.207-14.726,5.944-29.861,8.047-44.996 c0.498-3.587,1.004-7.183,0.938-10.814c-0.067-3.676-0.549-7.374-0.844-11.039c-0.402-5-0.894-10.027-2.073-14.892 c-2.019-1.196-4.273-1.866-6.548-1.688c-3.254,0.255-5.762,2.027-7.635,4.566c-5.465,7.416-2.416,27.568-1.444,36.366 c1.289,11.664,3.227,28.178,4.402,39.892C399.236,367.08,399.826,372.191,400.467,377.355z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M381.713,437.283c-0.101-0.003-0.206,0.007-0.303,0.019c-3.273,0.394-6.594,0.376-9.863-0.051 c-0.417-0.055-0.845-0.115-1.254-0.02c-0.371,0.086-0.699,0.294-1.025,0.492c-3.056,1.863-6.455,3.161-9.974,3.811 c-2.025,0.374-4.207,0.583-5.814,1.87c-0.752,0.602-1.34,1.72-0.766,2.494c0.195,0.263,0.492,0.43,0.788,0.57 c3.072,1.443,7.706,0.882,11.007,0.698c5.33-0.296,10.61,0.026,15.866-1.042c0.215-0.044,0.438-0.097,0.608-0.237 c0.238-0.195,0.323-0.516,0.393-0.816c0.337-1.454,0.623-2.932,0.795-4.415c0.068-0.585,0.396-2.698-0.007-3.193 C382.057,437.33,381.889,437.288,381.713,437.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757E96"
    },
    d: "M394.751,284.614c-12.121-0.195-15.83,12.456-17.272,22.187 c-3.047,20.55-5.186,41.234-6.413,61.972c-0.61,10.315-1.418,19.03-1.758,29.36c-0.362,10.605-0.934,28.954-0.473,39.503 c0.009,0.213,0.025,0.444,0.164,0.605c0.156,0.182,0.418,0.22,0.657,0.246c4.444,0.474,8.931,0.537,13.387,0.189 c0.209-0.016,0.429-0.038,0.599-0.161c0.192-0.14-1.521-0.811-1.448-1.037c3.411-10.529,5.742-29.353,6.812-40.357 c2.238-23.008,7.018-45.398,15.598-66.652C413.184,310.396,418.032,284.987,394.751,284.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M399.724,342.945 c4.863-11.614,9.04-23.515,12.503-35.62"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545D78"
    },
    d: "M397.134,311.869c0.039,0.007,0.078,0.012,0.117,0.018c1.109,0.18,2.219,0.344,3.331,0.483 c0.817,0.103,1.637,0.187,2.458,0.263c0.269,0.025,0.538,0.049,0.807,0.072c0.685,0.057,1.371,0.106,2.058,0.144 c0.388,0.022,0.775,0.038,1.164,0.054c0.303,0.013,0.607,0.029,0.911,0.039c0.001-0.003,0.001-0.005,0.002-0.008 c5.227,0.16,10.48-0.189,15.63-1.099c-0.773-9.286-2.8-18.237-8.197-25.824c-2.672-3.756-7.048-6.638-11.497-6.29 c-3.254,0.255-5.762,2.027-7.634,4.566c-0.407,0.552-0.756,1.191-1.073,1.875c-10.532-0.238-15.175,10.372-17.523,19.32 c2.373,1.438,4.979,2.537,7.542,3.431C389.088,310.261,393.093,311.206,397.134,311.869z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B699"
    },
    d: "M402.409,218.549c0.068-1.37-0.023-2.735-0.289-4.063c2.025,0.683,4.139,0.735,6.206,0.179 c1.016-0.274,1.992-0.679,2.944-1.126c0.339-0.159,0.95-0.657,1.513-0.969c-1.236,4.564-1.139,9.326,1.686,13.247 c-2.134,1.848-4.915,2.799-7.692,3.273c-2.386,0.407-8.095,0.784-6.723-3.232c0.449-1.314,1.413-2.324,1.794-3.687 C402.174,220.997,402.349,219.765,402.409,218.549z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C46E58"
    },
    d: "M407.936,214.755c-1.942,0.45-3.918,0.37-5.816-0.269c0.266,1.328,0.357,2.693,0.289,4.063 c-0.06,1.216-0.234,2.448-0.562,3.623c-0.034,0.123-0.078,0.24-0.121,0.357c0.235-0.029,0.471-0.07,0.706-0.115 C405.13,220.596,406.982,217.829,407.936,214.755z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B699"
    },
    d: "M399.315,196.573c1.403-2.018,3.071,0.818,5.528,0.88c2.137,0.054,3.797,0.008,5.692,1.115 c1.685,0.984,3.088,2.527,3.676,4.41c0.158,0.508,0.286,1.01,0.39,1.504c0.139,1.668,0.209,3.345,0.046,5.016 c-0.009,0.035-0.017,0.07-0.026,0.105c-1.198,2.887-3.173,5.197-5.615,6.824c-2.375,1.582-5.432,1.994-7.964,0.678 c-1.349-0.701-2.457-1.807-3.156-3.444c-0.698-1.634-0.916-3.433-0.999-5.208C396.761,205.749,397.769,198.796,399.315,196.573 z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M402.086,201.257c-1.92,0.277-3.482,0.582-5.243-0.449c-1.336-0.782-2.362-2.066-2.81-3.55 c-0.134-0.446-0.196-0.89-0.247-1.35c-0.023-0.207,0.027-1.039-0.041-1.135c0.606,0.862,1.931,0.898,2.863,0.406 c0.932-0.492,1.591-1.363,2.307-2.136c1.684-1.819,3.856-3.214,6.26-3.821c2.403-0.607,5.034-0.396,7.238,0.739 c1.385,0.713,2.581,1.797,3.42,3.11c0.415,0.649,0.761,1.366,0.963,2.111c0.093,0.346,0.364,2.146-0.077,2.31 c0.681-0.252,1.473,0.096,1.93,0.659c0.457,0.564,0.643,1.298,0.76,2.014c0.363,2.237,0.053,5.104-0.887,7.185 c-0.737,1.632-1.52,3.426-2.43,4.982c-0.792,1.354-1.886,2.575-3.296,3.261c-1.779,0.865-3.85,0.8-5.825,0.695 c-1.822-0.097-3.212-0.752-3.956-2.5c-0.338-0.795-0.452-1.759-0.506-2.611c-0.023-0.37-0.196-2.94,0.106-3.095 c-0.373,0.191-0.758,0.385-1.176,0.417c-0.418,0.032-0.88-0.14-1.065-0.516c-0.174-0.354-0.064-0.775,0.049-1.152 C400.977,204.974,401.531,203.115,402.086,201.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M417.261,192.893 c0.639,2.165,0.01,4.656-1.58,6.258"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M420.382,198.203 c-0.795-1.028-2.374-1.347-3.506-0.71"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B699"
    },
    d: "M406.626,209.516c-0.551,1.478-2.195,2.23-3.673,1.679c-1.478-0.551-2.23-2.195-1.679-3.673 c0.551-1.478,2.195-2.23,3.673-1.679C406.425,206.393,407.176,208.037,406.626,209.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M404.897,207.567c-0.368-0.194-0.837-0.183-1.196,0.029c-0.359,0.212-0.595,0.617-0.603,1.034 c0.31-0.126,0.693-0.042,0.923,0.201c0.23,0.243,0.292,0.63,0.15,0.933"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B699"
    },
    d: "M366.943,241.927c0.167-0.888,0.835-1.665,1.688-1.963c0.881-0.307,2.374-0.31,2.667-1.196 c0.147-0.443,0.293-0.609-0.063-0.911c-0.356-0.302-0.833-0.426-1.299-0.455c-1.432-0.088-2.882,0.717-3.564,1.98 c-0.209,0.388-0.512,0.896-0.935,0.773c-0.201-0.058-0.331-0.251-0.413-0.443c-0.499-1.167,0.191-2.473,0.858-3.553 c0.525-0.85,1.085-1.734,1.954-2.227c0.974-0.553,2.164-0.517,3.281-0.44c2.257,0.155,4.622,0.327,6.528,1.669 c0.5,0.352,0.957,0.762,1.455,1.115c1.28,0.907,2.792,1.416,4.28,1.913c-0.465,1.612-0.929,3.225-1.394,4.837 c-0.024,0.083-0.054,0.174-0.128,0.219c-0.078,0.047-0.178,0.027-0.267,0.005c-2.739-0.669-5.901-1.229-8.647-1.659 C370.976,241.341,368.889,241.591,366.943,241.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M382.011,234.599c-2.513,3.151-3.861,7.212-3.731,11.24c1.76,0.702,3.52,1.404,5.28,2.105 c0.606-2.788,1.211-5.575,1.817-8.363c0.182-0.838,0.928-2.622,0.451-3.314C385.318,235.528,382.86,234.967,382.011,234.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545D78"
    },
    d: "M400.16,241.208c-1.432-0.892-2.964-1.677-4.544-2.387c-2.714-1.22-5.569-2.218-8.296-3.163 c-1.033-0.358-2.124-0.758-3.187-0.98c-2.967,3.167-4.009,8.544-3.652,13.051c3.129,2.743,7.711,4.368,11.161,6.524 c1.932,1.208,3.85,2.473,5.971,3.305c2.121,0.832,4.499,1.208,6.688,0.576c1.144-0.331,2.271-0.997,2.772-2.077 c0.312-0.673,0.352-1.439,0.333-2.181C407.277,248.81,404.462,243.888,400.16,241.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B699"
    },
    d: "M348.601,258.8c-1.175-2.086-1.448-4.695-0.584-6.929c0.32-0.826,0.858-1.655,1.702-1.924 c1.014-0.323,2.125,0.293,2.767,1.142c0.642,0.849,0.944,1.898,1.354,2.881c0.443,1.062,1.023,2.066,1.722,2.98 c0.725,0.949,1.609,1.866,1.818,3.042c0.166,0.934-0.155,1.94-0.83,2.605C354.042,265.071,349.818,260.959,348.601,258.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4AE2D"
    },
    points: "376.89,257.278 361.716,264.633 341.642,246.413 356.817,239.058  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "374.41,256.519 361.378,262.836 344.034,247.092 357.066,240.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C8DDF7"
    },
    points: "359.047,244.106 348.216,249.356 347.16,248.397 357.99,243.147  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C8DDF7"
    },
    points: "364.58,249.128 353.749,254.378 352.693,253.419 363.523,248.169  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C8DDF7"
    },
    points: "366.413,250.792 355.582,256.042 354.526,255.083 365.356,249.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C8DDF7"
    },
    points: "368.246,252.456 357.415,257.706 356.359,256.747 367.189,251.497  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C8DDF7"
    },
    points: "370.079,254.12 359.248,259.37 358.192,258.41 369.022,253.161  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C8DDF7"
    },
    points: "371.912,255.784 361.081,261.033 360.025,260.074 370.855,254.825  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#485070"
    },
    points: "356.42,242.258 347.315,246.671 343.441,243.155 352.546,238.742  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B699"
    },
    d: "M350.173,257.134c-0.152,0.177-0.291,0.365-0.414,0.563c-1.147,1.843,1.074,3.555,2.486,4.549 c3.209,2.258,7.129,3.339,10.85,4.423c2.101,0.612,8.184-0.887,6.504-4.187c-1.147-2.253-4.541-3.551-6.773-4.153 c-2.317-0.434-4.296-1.399-5.165-3.747c-0.386-1.044-0.542-2.158-0.881-3.218c-0.083-0.261-0.185-0.529-0.388-0.712 c-0.203-0.184-0.535-0.253-0.75-0.083c-0.121,0.096-0.184,0.246-0.237,0.392c-0.649,1.812,0.516,3.154-1.715,4.217 c-0.741,0.353-1.554,0.548-2.273,0.945C350.947,256.382,350.524,256.727,350.173,257.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M361.351,255.167c-2.16,3.404-3.063,7.585-2.5,11.577c1.825,0.508,3.651,1.017,5.476,1.525 c0.302-2.837,0.604-5.673,0.906-8.51c0.091-0.853,0.64-2.706,0.091-3.344C364.739,255.735,362.235,255.442,361.351,255.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M398.888,222.127c1.074-0.963,2.617-1.142,4.054-1.276c3.707-0.345,7.414-0.691,11.122-1.036 c0.701,2.479,1.401,4.959,2.102,7.438c-0.029-0.104-12.024,0.372-13.168,0.336c-1.202-0.037-5.106,0.354-5.609-0.774 C396.831,225.565,397.969,222.951,398.888,222.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757E96"
    },
    d: "M423.258,283.941c0.011-3.949,0.233-7.893,0.484-11.832c0.327-5.131,0.714-10.261,0.78-15.404 c0.082-6.241-0.17-12.816-1.271-19.113c-0.275-1.568-0.602-3.119-0.989-4.643c-0.08-0.313-0.166-0.646-0.257-0.986 c-1.181-2.835-3.423-6.592-6.412-8.265c-0.496-0.031-1.001-0.007-1.498,0.026c-3.432,0.23-6.854,0.609-10.253,1.135 c-2.341,0.362-3.996,0.658-5.718,2.451c-4.393,4.572-8.513,14.816-9.66,21.111c-1.095,6.014-0.667,6.358-1.293,12.423 c-0.744,7.22-1.797,14.409-3.153,21.54c-1.144,6.014-2.857,12.541-7.851,16.083c8.278,3.475,16.657,6.98,25.527,8.365 c8.87,1.385,18.422,0.458,25.968-4.407C424.102,296.932,423.239,290.494,423.258,283.941z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757E96"
    },
    d: "M402.785,243.272c-0.341-0.662-0.761-1.313-1.382-1.725c-0.662-0.439-1.49-0.56-2.283-0.525 c-3.471,0.155-6.219,2.989-8.073,5.927c-1.855,2.939-3.283,6.258-5.927,8.514c-4.614,3.936-15.719,0.723-20.88-0.425 c-3.931,3.845-4.35,8.29-2.31,13.472c6.919,3.04,21.476,10.251,29.03,6.655c2.633-1.253,4.594-3.432,6.211-5.903 c0.935-1.427,1.755-2.952,2.523-4.452c1.721-3.359,3.374-6.802,4.164-10.492C404.649,250.629,404.515,246.626,402.785,243.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757E96"
    },
    d: "M405.856,230.778c-2.305-2.452-6.258-2.716-9.04-0.97c-1.627,1.021-2.453,3.128-3.294,4.801 c-1.029,2.048-1.906,4.171-2.622,6.348c-0.74,2.252-1.307,4.557-2.002,6.823c-1.138,3.714-2.619,7.329-3.471,11.119 c-0.852,3.79-1.039,7.859,0.387,11.472c2.037,5.16,8.828,2.419,11.855-0.452c2.606-2.473,3.855-6.013,5.016-9.413 c1.166-3.415,2.332-6.83,3.498-10.245c0.984-2.882,2.111-6.696,2.315-10.388C408.686,236.46,408.086,233.151,405.856,230.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M387.463,252.213 c1.617-7.565,4.459-14.867,8.383-21.535"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M408.204,245.737 c-1.49,4.01-2.981,8.02-4.471,12.03c-1.071,2.88-2.086,6.561-4.116,8.938c-2.022,2.366-3.905,4.953-6.384,6.899 c-2.411,1.892-5.446,3.178-8.496,2.879"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#485070",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M409.825,246.802 c-1.34,0.765-2.462,1.909-3.201,3.264"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485070"
    },
    d: "M363.109,245.048l-1.788,0.971l0.908-1.821l10.787-11.171c0.235-0.243,0.622-0.25,0.866-0.015l0,0 c0.243,0.235,0.25,0.622,0.015,0.866L363.109,245.048z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.74d23c62202f508a01d48077cde1490a.svg";
export { ForwardRef as ReactComponent };